import { Component, inject, OnInit } from "@angular/core";
import { LayoutService } from "@core/services/layout.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.page.html',
  styleUrls: ['./cookie-policy.page.scss']
})
export class CookiePolicyPage implements OnInit {
  private readonly layoutService = inject(LayoutService);
  private readonly languageService = inject(TranslateService);

  ngOnInit(): void {
    this._setupLayout();
  }

  private _setupLayout(): void {
    this.layoutService.updateHeaderConfig({ ...this.layoutService.headerConfig$(), useHeader: true, useLogoutButton: false, useBackButton: false });
  }

  get currentLange(): string {
    return this.languageService.currentLang;
  }
}
